export default {
  newTitle: 'New Budget Simulation',
  create: 'Create',
  name: 'Name',
  startDate: 'Start Date',
  endDate: 'End Date',
  mixMode: 'Mix Mode',
  free: 'Free',
  frozen: 'Frozen',
  freeDesc: 'The optimizer picks the best mix at each budget (one Plan Optimizer per budget).',
  frozenDesc: 'Every budget keeps the mix entered below (one Plan Calculator per budget).',
  budgetGrid: 'Budget Grid',
  referenceBudget: 'Reference budget (100%)',
  useHistoricalBudget: 'Use the historical spend ({value})',
  minPct: 'From',
  maxPct: 'To',
  points: 'Points',
  mixTitle: 'Media Mix',
  useHistoricalMix: 'Use historical mix',
  total: 'Total',
  mixMustAddUp: 'The shares must add up to 100%.',
  frozenTimeHint: 'Each channel spreads its budget over the period following its own historical spend pattern in the same months (or weeks).',
  nameRequired: 'Name is required',
  mustBeAfterStartDate: 'Must be after the start date',
  maxAboveMin: 'Must be greater than the start of the grid',
  noPeriods: 'The selected period has no model periods.',
  gridTooSmall: 'The grid needs at least 2 different budgets.',
  createFailed: 'The budget simulation could not be created. Please try again.',
  editTitle: 'Edit Budget Simulation',
  save: 'Save',
  editWarning: 'Saving recomputes every budget of the grid from scratch.',
  namePlaceholder: 'e.g. Budget scenarios 2027',
  pickDate: 'Pick a date',
  pickMode: 'Pick how the mix is set at each budget',
  modelRange: 'Model data: {from} → {to}',
  periodMonths: '{count} month | {count} months',
  periodWeeks: '{count} week | {count} weeks',
  setupFirst: 'Pick the mix mode and the period to set up the budget grid.',
  historicalSpendHint: 'The historical spend of the period',
  typeAmountHint: 'Type an amount, such as 500k or 2m',
  ofReference: 'of the reference',
  pointsHint: 'Budgets to simulate, up to {max}',
  gridPreview: '{count} budgets to simulate',
  mixIntro: 'Share of every budget per channel',
  historicalShort: 'Historical {value}%',
  referenceRequired: 'Type a reference budget greater than 0.'
}
